export const SMARTY_STREETS_KEY = '421007431137765';
export const AMPLITUDE_KEY_PROD = 'a55a37a212024ad62e933b63270830aa';
export const AMPLITUDE_KEY_STAGING = '887c7f25061624ccc970005c608ceb44';
export const STRIPE_API_KEY_PROD = 'pk_live_lcAXfmHJgcCFT3fnIs4id7g7';
export const STRIPE_API_KEY_STAGING = 'pk_test_pu8LyOwwUzSbwOFy8mo4W1J2';
export const BRAZE_WEB_API_KEY_PROD = '1ac98f17-d6c7-4ff0-a92c-7b8fffbe2264';
export const BRAZE_WEB_API_KEY_DEV = '7501190f-c655-4892-bbab-c63faf077eaf';
